import { useEffect, useState } from 'react';

export function usePreloadImages(urls: string[]): boolean {
    const [isContentLoaded, setIsContentLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (urls.length === 0) {
            setIsContentLoaded(true);
            return;
        }

        let loadedCount = 0;

        const onLoad = () => {
            ++loadedCount;
            if (loadedCount === urls.length) {
                setIsContentLoaded(true);
            }
        };

        urls.forEach((url) => {
            const img = new Image();
            img.onload = onLoad;
            img.onerror = onLoad;
            img.src = url;
        });
    }, [urls]);

    return isContentLoaded;
}
